import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=103f9e1a&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/SocialIcons/SocialIcons.less?vue&type=style&index=0&id=103f9e1a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f9e1a",
  null
  
)

export default component.exports